import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductJourneys } from '@/features/journeys'
import { JourneysListSkeleton } from '@/features/journeys/components/JourneysListSkeleton'

export const Route = createFileRoute('/_event/jornadas/')({
  // Declarado ao lado do componente que ele representa: rota nova nasce
  // coberta pelo default, e nenhum registro central precisa ser lembrado.
  staticData: { bootSkeleton: JourneysListSkeleton },
  component: DigitalProductJourneysPage
})

function DigitalProductJourneysPage() {
  return <DigitalProductJourneys />
}
